module.exports = __webpack_public_path__ + "img/HE7302-01.625cc537.jpg";